















































































import Vue from 'vue';
import * as Plottable from 'plottable';
import { mapGetters } from 'vuex';
import AdminListModel from '@/models/AdminListModel';

export default Vue.extend({
  data: function() {
    return {
      barchartDataset: new Plottable.Dataset([]),
      showUserPerformanceTable: false,
    };
  },
  computed: {
    ...mapGetters({
      listPerformance: 'listPerformance',
      listById: 'listById',
    }),
    questionsBase() {
      const tableLabel = [...Array(this.numberOfQuestions).keys()];
      return tableLabel.map(label => {
        return { position: label + 1, correct: 0 };
      });
    },
    dataBaseUserInfo() {
      if (this.listPerformance(this.listId)) {
        const listItems = this.list.listItems();
        return this.listPerformance(this.listId).map(user => {
          const questions = user.firstRepliesOfQuestions
            .map(question => {
              const listItem = listItems.find(
                listItemElement =>
                  listItemElement.questionId === question.questionId,
              );
              return {
                position: listItem.position,
                correct: question.correct,
              };
            })
            .sort((A, B) => A.position - B.position);
          return {
            name: user.userOfReplies.name,
            email: user.userOfReplies.email,
            questions,
          };
        });
      } else {
        return [];
      }
    },
    completeUserInfo() {
      return this.dataBaseUserInfo
        ? this.dataBaseUserInfo.map(user => {
            return {
              name: user.name,
              email: user.email,
              total: user.questions.reduce((result, question) => {
                return result + question.correct;
              }, 0),
              questions: this.questionsBase.map(question => {
                const userAnswer = user.questions[question.position - 1];
                return {
                  position: question.position,
                  correct: userAnswer && userAnswer.correct ? '✓' : '✕',
                };
              }),
            };
          })
        : [];
    },
    numberOfQuestions() {
      return this.barchartData.length;
    },
    barchartData() {
      return this.list
        ? this.list.questions().map((question, index) => ({
            index: index + 1,
            distinctReplies: question.distinctUserReplies,
          }))
        : [];
    },
    numberOfUsers() {
      return Math.max(
        ...this.barchartData.map(barchart => barchart.distinctReplies),
      );
    },
    listId(): number {
      const listId = +this.$route.params.listId;
      return listId;
    },
    list(): AdminListModel {
      return this.listById(this.listId);
    },
  },
  watch: {
    barchartData: function(newValue) {
      this.barchartDataset.data(newValue);
    },
  },
  mounted: function() {
    this.setUpForChart();
  },
  methods: {
    userAnswerOfQuestion: function(col, row) {
      return row.questions[col.position - 1].correct;
    },
    setUpForChart: async function() {
      await this.$store.dispatch('GET_LIST_PERFORMANCE', this.listId);
      if (this.numberOfUsers < 1000) {
        this.$store.dispatch('GET_LIST_PERFORMANCE_BY_USER', this.listId);
        this.showUserPerformanceTable = true;
      } else {
        this.showUserPerformanceTable = false;
      }
      this.buildBarChart();
    },
    buildBarChart: function() {
      const xScale = new Plottable.Scales.Category();
      const yScale = new Plottable.Scales.Linear();
      yScale.domain([0, this.numberOfUsers]);
      const plotTarget = this.$refs.svg;
      const labelInclinationLeft = 270;
      const plot = new Plottable.Plots.Bar()
        .addDataset(this.barchartDataset)
        .x(d => d.index, xScale)
        .y(d => d.distinctReplies, yScale)
        .attr('fill', '#00E88F');

      const yAxis = new Plottable.Axes.Numeric(yScale, 'left');
      const xAxis = new Plottable.Axes.Category(xScale, 'bottom');
      const yLabel = new Plottable.Components.AxisLabel(
        'Qtd Alunos',
        labelInclinationLeft,
      );
      const xLabel = new Plottable.Components.AxisLabel('Questão');
      const table = new Plottable.Components.Table([
        [yLabel, yAxis, plot],
        [null, null, xAxis],
        [null, null, xLabel],
      ]);
      table.renderTo(plotTarget);
      window.addEventListener('resize', function() {
        plot.redraw();
      });
    },
  },
});
